export { default as AddPartsListArea } from "./addPartsListArea";
export { default as PartsConfirmArea } from "./partsConfirmArea";
export { default as PartsEditListArea } from "./partsEditListArea";
export { default as PartsLabelListArea } from "./partsLabelListArea";
export { default as PartsLabelListCompleteArea } from "./partsLabelListCompleteArea";
export { default as PartsLabelListOrderCompArea } from "./partsLabelListOrderCompArea";
export { default as PartsLabelListOrderConfArea } from "./partsLabelListOrderConfArea";
export { default as PartsListArea } from "./partsListArea";
